<template>
  <div>
    <el-dialog
      title="导出记录"
      :visible.sync="exportListModal"
      width="1100px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      class="exportListModal"
    >
      <el-table stripe :data="tableData" height="360">
        <el-table-column
          prop="fileName"
          label="文件名称"
          width="170"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status === 0">已发起</el-tag>
            <el-tag type="info" v-else-if="row.status === 1">处理中</el-tag>
            <el-tag type="warning" v-else-if="row.status === 2">已完成</el-tag>
            <el-tag type="danger" v-else-if="row.status === 3">导出失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="downloadUrl"
          label="下载链接"
          minWidth="130"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="insertDate"
          label="导出时间"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" width="110" align="center">
          <template slot-scope="{ row }">
            <span
              class="blue_Box"
              v-if="row.status === 2"
              @click="handleDownload(row)"
              >下载</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
        "
      >
        <el-button icon="el-icon-refresh" size="small" type="primary" @click="handleRefresh">
          刷新
        </el-button>
        <!-- 分页 -->
        <el-pagination
          @size-change="handlePageSize"
          @current-change="handlePage"
          :current-page="pageInfo.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getMyDownloadPage } from '@/api/fileExportAsync'
export default {
  data() {
    return {
      exportListModal: false,
      tableColumns: [
        {
          title: '文件名称',
          key: 'fileName',
          width: 100
        },
        {
          title: '状态',
          key: 'requestType',
          width: 160,
          slot: 'status'
        },
        {
          title: '下载链接',
          key: 'downloadUrl',
          width: 400
        },
        {
          title: '导出时间',
          key: 'insertDate',
          sortable: true,
          width: 160
        },
        {
          title: '操作',
          slot: 'action',
          width: 100
        }
      ],
      tableData: [],
      pageInfo: {
        total: 100,
        page: 1,
        limit: 10
      }
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    init() {
      this.exportListModal = true
      this.handleRefresh()
    },
    // 下载
    handleDownload(row) {
      console.log('下载：', row)
      window.open(row.downloadUrl)
    },
    // 刷新
    handleRefresh() {
      this.getTableData()
    },
    handlePage(current) {
      this.pageInfo.page = current
      this.getTableData()
    },
    handlePageSize(size) {
      this.pageInfo.limit = size
      this.getTableData()
    },
    getTableData() {
      getMyDownloadPage(this.pageInfo)
        .then((res) => {
          this.tableData = res.data.records
          this.pageInfo.total = parseInt(res.data.total)
        })
        .finally(() => {
          this.loading = false
        })
    },
    mounted() {}
  }
}
</script>
<style lang="scss">
.exportListModal {
  .ivu-table-wrapper {
    border: none !important;
    margin: 0 -16px;
  }
  .ivu-table:after {
    width: 0;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }
}
</style>
